/**
 * Flag do onboarding único de permissões (/onboarding/permissoes).
 *
 * localStorage sobrevive a updates OTA (mesma origem do webview), então o
 * onboarding roda UMA vez por instalação — inclusive pra usuários existentes
 * que atualizarem pro shell 1.1.x (eles veem só os passos ainda pendentes;
 * os já concedidos auto-skipam).
 */

const DONE_KEY = 'bow-perms-onboarding-v1';

export function permissionsOnboardingDone(): boolean {
  try {
    return window.localStorage.getItem(DONE_KEY) !== null;
  } catch {
    return true; // storage indisponível → nunca prender o usuário no fluxo
  }
}

export function markPermissionsOnboardingDone(): void {
  try {
    window.localStorage.setItem(DONE_KEY, String(Date.now()));
  } catch {
    /* silencioso */
  }
}
